import React from 'react';
import { cn } from '../design-system/cn';
import StadiumAtmosphere from '../components/atmosphere/StadiumAtmosphere';

/**
 * Shared stadium atmosphere — fixed glow layers behind children.
 */
export default function StadiumShell({ children, className }) {
  return (
    <div
      className={cn(
        'relative min-h-screen min-h-[100dvh] bg-surface-app text-white',
        'selection:bg-emerald-500 selection:text-black overflow-x-hidden',
        className
      )}
    >
      <StadiumAtmosphere />
      <div className="relative z-10">{children}</div>
    </div>
  );
}
